<template>

    <div>

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Button</h2>

        <div class="text-center">
            <div class="blocks-action-bar-inline">
                <div class="device-selector--large inline-style">

                    <i class="fas fa-desktop active" data-device="desktopSettings" v-b-tooltip.hover.top title="Desktop" @click="switchDevice"></i>
                    <i class="fas fa-tablet-alt" data-device="tabletSettings" v-b-tooltip.hover.top title="Tablet" @click="switchDevice"></i>
                    <i class="fas fa-mobile-alt" data-device="mobileSettings" v-b-tooltip.hover.top title="Phone" @click="switchDevice"></i>

                </div>
                
            </div>
        </div>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <vstyle v-if="!settingsFromWeebly.settings.useCustomFont">
                @import url('https://fonts.googleapis.com/css?family={{settingsFromWeebly.settings.fontGoogleLoad}}');
            </vstyle>
            <vstyle>
                <!-- @import url("https://appjustable.com/weebly/app_in_process/buttons/styles/main_styles.css"); -->

                #{{uniqueId+'-wrapper'}} {
                    text-align: {{settingsFromWeebly.settings.buttonAlignement}};
                    margin: {{settingsFromWeebly.settings.buttonMarginTop}}px auto {{settingsFromWeebly.settings.buttonMarginBottom}}px;
                }

                a#{{uniqueId}} {
                    background-color: {{settingsFromWeebly.settings.buttonBg}};
                    padding: {{settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontal}}px;
                    border-radius: 2px;
                    color: {{settingsFromWeebly.settings.textColor}};
                    text-decoration: none;
                    display: inline-block;
                    line-height: {{settingsFromWeebly.settings.lineHeight}};
                    font-size: {{settingsFromWeebly.settings.buttonTextFontSize}}px;
                    text-align: center;
                    width: {{settingsFromWeebly.settings.buttonWidthValue}};
                    max-width: {{settingsFromWeebly.settings.buttonMaxWidth}}{{settingsFromWeebly.settings.setButtonWidth ? 'px': ''}};
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    font-family: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontName : settingsFromWeebly.settings.fontFamily}};
                    font-style: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontStyle : settingsFromWeebly.settings.fontStyle}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontWeight : settingsFromWeebly.settings.fontWeight}};
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacing}}px;
                    border: {{settingsFromWeebly.settings.borderWidth}}px {{settingsFromWeebly.settings.borderStyle}} {{settingsFromWeebly.settings.borderColor}};
                    border-radius: {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusLeftTop}}px {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusRightTop}}px {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusRightBottom}}px {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusLeftBottom}}px;
                    overflow: hidden;
                }
                a#{{uniqueId}} i {
                    font-size: inherit;
                    font-weight: normal;
                }
                a#{{uniqueId}}:hover{
                    background-color:  {{settingsFromWeebly.settings.buttonBgHover}};
                    color: {{settingsFromWeebly.settings.textColorHover}};
                    border-color: {{settingsFromWeebly.settings.borderColorHover}};
                }
                a#{{uniqueId}}.button-shadow-normal {
                    -webkit-box-shadow: {{settingsFromWeebly.settings.buttonShadowHorizontal}}px {{settingsFromWeebly.settings.buttonShadowVertical}}px {{settingsFromWeebly.settings.buttonBlurRadius}}px {{settingsFromWeebly.settings.buttonSpreadRadius}}px {{settingsFromWeebly.settings.buttonBoxShadowColor}};
                    box-shadow: {{settingsFromWeebly.settings.buttonShadowHorizontal}}px {{settingsFromWeebly.settings.buttonShadowVertical}}px {{settingsFromWeebly.settings.buttonBlurRadius}}px {{settingsFromWeebly.settings.buttonSpreadRadius}}px {{settingsFromWeebly.settings.buttonBoxShadowColor}};
                }
                a#{{uniqueId}}.button-shadow-hover:hover {
                    -webkit-box-shadow: {{settingsFromWeebly.settings.buttonShadowHorizontal}}px {{settingsFromWeebly.settings.buttonShadowVertical}}px {{settingsFromWeebly.settings.buttonBlurRadius}}px {{settingsFromWeebly.settings.buttonSpreadRadius}}px {{settingsFromWeebly.settings.buttonBoxShadowColor}};
                    box-shadow: {{settingsFromWeebly.settings.buttonShadowHorizontal}}px {{settingsFromWeebly.settings.buttonShadowVertical}}px {{settingsFromWeebly.settings.buttonBlurRadius}}px {{settingsFromWeebly.settings.buttonSpreadRadius}}px {{settingsFromWeebly.settings.buttonBoxShadowColor}};
                }
                a#{{uniqueId}}.button-shadow-hover-off:hover {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                }
                a#{{uniqueId}}.hvr-sweep-to-right:before, 
                a#{{uniqueId}}.hvr-sweep-to-left:before, 
                a#{{uniqueId}}.hvr-sweep-to-bottom:before,
                a#{{uniqueId}}.hvr-sweep-to-top:before,
                a#{{uniqueId}}.hvr-radial-out:before,
                a#{{uniqueId}}.hvr-rectangle-out:before,
                a#{{uniqueId}}.hvr-shutter-in-horizontal,
                a#{{uniqueId}}.hvr-shutter-in-vertical,
                a#{{uniqueId}}.hvr-shutter-out-horizontal:before,
                a#{{uniqueId}}.hvr-shutter-out-vertical:before {
                    background:  {{settingsFromWeebly.settings.buttonBgHover}};
                }
                a#{{uniqueId}}.hvr-sweep-to-right:hover, 
                a#{{uniqueId}}.hvr-sweep-to-left:hover, 
                a#{{uniqueId}}.hvr-sweep-to-bottom:hover,
                a#{{uniqueId}}.hvr-sweep-to-top:hover,
                a#{{uniqueId}}.hvr-radial-out:hover,
                a#{{uniqueId}}.hvr-rectangle-out:hover,
                a#{{uniqueId}}.hvr-shutter-in-horizontal:before,
                a#{{uniqueId}}.hvr-shutter-in-vertical:before,
                a#{{uniqueId}}.hvr-shutter-out-horizontal:hover,
                a#{{uniqueId}}.hvr-shutter-out-vertical:hover {
                    background: {{settingsFromWeebly.settings.buttonBg}};
                }
                @media(max-width: 768px) {
                    #{{uniqueId+'-wrapper'}} {
                        text-align: {{settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}};
                    }
                    a#{{uniqueId}} {
                        font-size: {{settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px;
                        letter-spacing: {{settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}};
                        line-height: {{settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}};
                        padding: {{settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px;
                        width: {{settingsFromWeebly.settings.buttonWidthValueTablet || settingsFromWeebly.settings.buttonWidthValue}};
                        max-width: {{settingsFromWeebly.settings.buttonMaxWidthTablet || settingsFromWeebly.settings.buttonMaxWidth}}{{settingsFromWeebly.settings.setButtonWidthTablet ? 'px': ''}};
                    }
                }
                @media(max-width: 576px) {
                    #{{uniqueId+'-wrapper'}} {
                        text-align: {{settingsFromWeebly.settings.buttonAlignementPhone || settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}};
                    }
                    a#{{uniqueId}} {
                        font-size: {{settingsFromWeebly.settings.buttonTextFontSizePhone || settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px;
                        letter-spacing: {{settingsFromWeebly.settings.letterSpacingPhone || settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}};
                        line-height: {{settingsFromWeebly.settings.lineHeightPhone ||settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}};
                        padding: {{settingsFromWeebly.settings.buttonPaddingVerticalPhone || settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalPhone || settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px;
                        width: {{settingsFromWeebly.settings.buttonWidthValuePhone ||  settingsFromWeebly.settings.buttonWidthValueTablet || settingsFromWeebly.settings.buttonWidthValue}};
                        max-width: {{settingsFromWeebly.settings.buttonMaxWidthPhone ||  settingsFromWeebly.settings.buttonMaxWidthTablet || settingsFromWeebly.settings.buttonMaxWidth}}{{settingsFromWeebly.settings.setButtonWidthPhone ? 'px': ''}};
                    }
                }
            </vstyle>

            <vstyle v-if="deviceStylesSetttings.tabletStyles">

                #{{uniqueId+'-wrapper'}} {
                    text-align: {{settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}};
                }

                a#{{uniqueId}} {
                    font-size: {{settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px;
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}}px;
                    line-height: {{settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}};
                    padding: {{settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px;
                    width: {{settingsFromWeebly.settings.buttonWidthValueTablet || settingsFromWeebly.settings.buttonWidthValue}};
                    max-width: {{settingsFromWeebly.settings.buttonMaxWidthTablet || settingsFromWeebly.settings.buttonMaxWidth}}{{settingsFromWeebly.settings.setButtonWidthTablet ? 'px': ''}};
                }

            </vstyle>

            <vstyle v-if="deviceStylesSetttings.mobileStyles">

                #{{uniqueId+'-wrapper'}} {
                    text-align: {{settingsFromWeebly.settings.buttonAlignementPhone || settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}};
                }

                a#{{uniqueId}} {
                    font-size: {{settingsFromWeebly.settings.buttonTextFontSizePhone || settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px;
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacingPhone || settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}}px;
                    line-height: {{settingsFromWeebly.settings.lineHeightPhone ||settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}};
                    padding: {{settingsFromWeebly.settings.buttonPaddingVerticalPhone || settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalPhone || settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px;
                    width: {{settingsFromWeebly.settings.buttonWidthValuePhone ||  settingsFromWeebly.settings.buttonWidthValueTablet || settingsFromWeebly.settings.buttonWidthValue}};
                    max-width: {{settingsFromWeebly.settings.buttonMaxWidthPhone ||  settingsFromWeebly.settings.buttonMaxWidthTablet || settingsFromWeebly.settings.buttonMaxWidth}}{{settingsFromWeebly.settings.setButtonWidthPhone ? 'px': ''}};
                }

            </vstyle>

            <div :id="uniqueId+'-wrapper'">

                <a @click="preventClick" :id="uniqueId" :href="settingsFromWeebly.settings.buttonHref" :target="settingsFromWeebly.settings.buttonTarget" :class="[settingsFromWeebly.settings.hoverClass, settingsFromWeebly.settings.useButtonShadowOnHover && settingsFromWeebly.settings.useButtonShadow ? 'button-shadow-hover' : 'button-shadow-hover-off', , settingsFromWeebly.settings.useButtonShadowOnNormal  && settingsFromWeebly.settings.useButtonShadow ? 'button-shadow-normal' : '']">

                    <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconBefore" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-right':settingsFromWeebly.settings.iconMargin+'px'}"></i>

                    {{settingsFromWeebly.settings.buttonText}}

                    <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconAfter" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-left':settingsFromWeebly.settings.iconMargin+'px'}"></i>
                </a>
            </div>
           

        </div>

    </div>

</template>

<script>

export default {

    name: 'Button',

    data () {

        return {

            uniqueId: 'button-'+Math.random().toString(36).substr(2, 16)
            
        }
    },

    methods: {
        preventClick() {
            event.preventDefault();
        },
        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--large i');
            icons.forEach(icon => {
                console.log(icon)
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.desktopStyles = true
            }

        }

    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

    },

    components: {

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        }

    },
    
    mounted() {

        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';

</style>



// WEBPACK FOOTER //
// src/components/elements/Button.vue